import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=5b2ca759&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=5b2ca759&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=5b2ca759&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ca759",
  null
  
)

export default component.exports